import React from "react";
import { Link } from "react-router-dom";

const shippingData = [
  {
    id: 1,
    icon: "ph-fill ph-truck",
    title: "Fast & Reliable Delivery",
    description: "Quick shipping gets your supplies fast.",
  },
  {
    id: 2,
    icon: "ph-fill ph-seal-check",
    title: "Authentic Products",
    description: "Genuine HP items with full warranty.",
  },
  {
    id: 3,
    icon: "ph-fill ph-tag",
    title: "Best Prices",
    description: "Save more with top deals daily.",
  },
  {
    id: 4,
    icon: "ph-fill ph-headset",
    title: "Expert Support",
    description: "24/7 help from certified experts.",
  },
];

const PromotionalTwo = () => {
  return (
    <section className="offer">
      <div className="container container-lg">
        <div style={{ padding: "80px 40px" }}>
          {/* Heading */}
          <h4 className="text-center fw-bold mb-3">
            Trusted Printing Solutions That Work Every Time
          </h4>
          <p
            className="text-center mx-auto text-muted"
            style={{ fontSize: "16px", maxWidth: "800px" }}
          >
            Whether you need a wireless home printer that connects seamlessly or
            a powerful office printer built for busy days, Printing Dealz has
            you covered. Every model we offer is tested for performance and
            reliability, paired with genuine ink cartridges and essential office
            supplies to keep your printing smooth and stress-free.
          </p>

          {/* Icons Section */}
          <div className="row gy-4 mt-5">
            {shippingData.map((item) => (
              <div className="col-lg-6 col-sm-6" key={item.id}>
                <div
                  className="d-flex align-items-center gap-16 p-30 rounded-4 shadow-sm bg-white"
                  style={{
                    transition: "all 0.3s ease",
                    border: "1px solid #f0f0f0",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(0,0,0,0.08)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(0,0,0,0.05)")
                  }
                >
                  {/* Icon */}
                  <div
                    className="d-flex align-items-center justify-content-center rounded-circle"
                    style={{
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#3243b4",
                      color: "#fff",
                      flexShrink: 0,
                      fontSize: "26px",
                    }}
                  >
                    <i className={item.icon}></i>
                  </div>

                  {/* Content */}
                  <div>
                    <h6 className="fw-semibold mb-1 text-dark">{item.title}</h6>
                    <p
                      className="mb-0 text-muted"
                      style={{ fontSize: "14px", lineHeight: "1.4" }}
                    >
                      {item.description}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default PromotionalTwo;
